import { useToast } from "@design";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { addPinMutation, listPinsOptions, listPinsQueryKey, removePinMutation } from "@/api";

/** Starred spaces are the sidebar's pinned spaces: same query, so both update together. */
export function useSpaceStars() {
  const { t } = useTranslation("spaces");
  const toast = useToast();
  const queryClient = useQueryClient();
  const pins = useQuery({ ...listPinsOptions(), select: (r) => new Set(r.data.map((s) => s.uuid)) });
  const options = {
    onError: () => toast.error(t("card.starFailed")),
    onSettled: () => queryClient.invalidateQueries({ queryKey: listPinsQueryKey() }),
  };
  const add = useMutation({ ...addPinMutation(), ...options });
  const remove = useMutation({ ...removePinMutation(), ...options });

  return {
    isStarred: (uuid: string) => pins.data?.has(uuid) ?? false,
    toggle: (uuid: string, starred: boolean) =>
      starred ? remove.mutate({ path: { space_uuid: uuid } }) : add.mutate({ body: { spaceUuid: uuid } }),
  };
}
